import * as DictionaryConstants from '../../../../constants/DictionaryConstants'

export default {
  memberAvatarUrl: state => {
    const memberDetail = state.memberDetail
    let avatorUrl = ''
    if (memberDetail && memberDetail.avatar) {
      avatorUrl = memberDetail.avatar
    }
    return avatorUrl
  },
  // 会员认证状态
  memberVerificationStatus: state => {
    if (!state.memberDetail) {
      return
    }
    return state.memberDetail.verificationStatus === DictionaryConstants.MEMBER_VERIFICATION_STATUS_PASSED
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/store/getters.js